module.exports = __webpack_public_path__ + "99deb724256a8df9405783a7d874c02f.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/Pachantiew/newtv.png
// module id = 1377
// module chunks = 47